import { useEffect } from "react";
import useFetch from "hooks/useFetch";
import mixpanel from "mixpanel-browser";
import { useSetRecoilState } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import { setAuthHeaders } from "api";
import { userAtom } from "recoil/userAtom";
import { useNavigate } from "react-router-dom";
import { sendMessage } from "utils/webview";
import useIsInappWebview from "./useIsInappWebview";
import useGetDeviceInfo from "./useGetDeviceInfo";
import { compareVersions } from "../logic/logics_common";

export default function useLogin({
  url,
  requestBody,
}: {
  url: string;
  requestBody: string;
}) {
  let navigate = useNavigate();

  const [loginResult, login] = useFetch({
    url: url,
    requestBody: requestBody,
  });

  const setPatientState = useSetRecoilState(patientAtom);
  const setUser = useSetRecoilState(userAtom);
  const isInappWebview = useIsInappWebview();
  const { appVersion } = useGetDeviceInfo();

  useEffect(() => {
    if (loginResult) {
      const result = loginResult.result;

      mixpanel.identify(result.trackId);

      setAuthHeaders(result.accessToken);
      sendMessage(
        JSON.stringify({
          event: "value",
          params: {
            accessToken: result.accessToken,
          },
        })
      );

      setUser(result);
      if (result.role === "patient" && result.userId) {
        setPatientState({
          patientId: Number(`${result.userId}`),
          nickname: result.nickname,
        });
      }

      if (isInappWebview && compareVersions(appVersion, "1.1.20") >= 0) {
        if (result.isFirstLogin) {
          const msg = JSON.stringify({
            event: "send_fb_event",
            params: {
              eventName: "Login",
            },
          });
          sendMessage(msg);
        }
      }

      navigate("/", { replace: true });
    }
  }, [loginResult]);

  return login;
}